import { render } from "./SelectProduct.vue?vue&type=template&id=13e66232&scoped=true"
import script from "./SelectProduct.vue?vue&type=script&lang=js"
export * from "./SelectProduct.vue?vue&type=script&lang=js"

import "./SelectProduct.vue?vue&type=style&index=0&id=13e66232&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e66232"]])

export default __exports__